<template>
  <div>
    <cursor-title :cursortitle="$attrs.cursortitletitle" class="cursor__title"></cursor-title>
    <div class="cursor_list">
      <cursordetail :d-height="dHeight" v-for="(item,index) in cursorList" :cursorDetail="item" class="cursor_item" :key="index" v-on="$listeners" @setEqual="getEqual"></cursordetail>
    </div>
  </div>
</template>
<script>
import CursorTitle from "@/components/CursorTitle";
import Cursordetail from "@/components/Cursordetail"
export default {
  components: {
    CursorTitle,
    Cursordetail
  },
  props:{
    cursorList:{
      type:Array,
      default:()=>{
        return []
      }
    }
  },
  data() {
    return {
      dHeight:0
    };
  },
  methods:{
    getEqual(h){
      this.dHeight = (this.dHeight<h?h:this.dHeight)
    }
  }
};
</script>
<style lang="scss" scoped>
.cursor__title {
  margin-bottom: 29px;
}
.cursor_list {
  display: flex;
  flex-wrap: wrap;
  margin-left: -13px;
  margin-right: -13px;
  .cursor_item{
    width: 33.33%;
  }
}
</style>